module.exports = __webpack_public_path__ + "assets/img/hero-mob.0928b4ae.svg";